export const CHECKOUT_TERMS = (seller: string) => {
  return {
    customer: [
      {
        url: 'https://terms.inpock.co.kr/commerce/customer-privacy',
        text: '개인정보 수집 및 이용 동의',
      },
      {
        url: `https://terms.inpock.co.kr/commerce/customer-privacy-party?seller=${seller}`,
        text: '개인정보 제3자 제공동의',
      },
      {
        url: 'https://terms.inpock.co.kr/commerce/consignment',
        text: '결제 대행 서비스 이용을 위한 개인정보 제3자 제공 및 위탁',
      },
    ],
    nonCustomer: [
      {
        url: '#',
        text: '만 14세 이상 이용자',
      },
      {
        url: 'https://terms.inpock.co.kr/market/non-member/terms',
        text: '서비스 약관',
      },
      {
        url: `https://terms.inpock.co.kr/commerce/customer-privacy-party?seller=${seller}`,
        text: '개인정보 제3자 제공동의',
      },
      {
        url: 'https://terms.inpock.co.kr/commerce/consignment',
        text: '결제 대행 서비스 이용을 위한 개인정보 제3자 제공 및 위탁',
      },
      {
        url: 'https://terms.inpock.co.kr/commerce/privacy-non-member',
        text: '비회원 개인정보 수집 및 이용',
      },
    ],
  };
};
